import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import API from "../api";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import "./EmployeeProfile.css";

export default function EmployeeProfileDeatails() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [employee, setEmployee] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [bankDetails, setBankDetails] = useState(null);
const [overview, setOverview] = useState(null);
const [loadingOverview, setLoadingOverview] = useState(true);


  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  // useEffect(() => {
  //   fetchEmployee();
  // }, [id]);

  const fetchEmployee = async () => {
    try {
      const res = await API.get(`/profile/${id}`);
      setEmployee(res.data); // API returns array
    } catch (err) {
      console.error(err);
    }
  };
  const fetchBankDetails = async () => {
    try {
      const res = await API.get(`/profile/bank-details/${id}`);
      setBankDetails(res.data);
    } catch (err) {
      console.log("No bank details");
    }
  };
    useEffect(() => {
    if (!employee?.id) return;

    const fetchOverview = async () => {
      try {
        const res = await API.get(
          `/employee/overview/${employee.id}`
        );
        setOverview(res.data);
      } catch (err) {
        console.error("Overview fetch failed", err);
      } finally {
        setLoadingOverview(false);
      }
    };

    fetchOverview();
  }, [employee?.id]);

  useEffect(() => {
    fetchEmployee();
    fetchBankDetails();
  }, [id]);

  if (!employee) {
    return <p style={{ padding: 20 }}>Loading employee profile...</p>;
  }

  return (
    <div className="dashboard-wrapper">
      {/* Sidebar */}
      <div className={`sidebar-container ${sidebarOpen ? "open" : "closed"}`}>
        <Sidebar />
      </div>

      <div className={`page-area ${sidebarOpen ? "" : "full"}`}>
        <Navbar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />

        <div className="main-content">
          <div className="container-fluid py-4">

            <div style={{ padding: 20 }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: 20,
                }}
              >
                <h2 style={{ margin: 0 }}>Employee Details</h2>

                <button
                  onClick={() => navigate("/AdminDashboard/Profile")}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    background: "#ed3338",
                    color: "#fff",
                    border: "none",
                    padding: "6px 19px",
                    borderRadius: "20px",
                    cursor: "pointer",
                    fontSize: "14px",
                    marginRight: "12px"
                  }}
                >
                  ← Back
                </button>
              </div>

              {/* PROFILE CARD */}
              <div className="profile-card">
                {/* LEFT */}
                <div className="profile-left">
                  <img
                    src={
                      employee.profile_image
                        ? `http://163.227.92.37:7888/uploads/profile/${employee.profile_image}`
                        : "/default-user.png"
                    }
                    alt="Profile"
                    className="profile-avatar"
                  />

                  <div className="profile-header">
                    <h4 className="emp-name">{employee.name}</h4>
                    <span className="emp-badge">Employee</span>
                  </div>

                  <div className="profile-info-grid">
                    <div className="info-item">
                      <span className="label">User ID</span>
                      <span className="value">{employee.id}</span>
                    </div>

                    <div className="info-item">
                      <span className="label">Email</span>
                      <span className="value">{employee.email || "-"}</span>
                    </div>

                    <div className="info-item">
                      <span className="label">Mobile</span>
                      <span className="value">{employee.phone_number || "-"}</span>
                    </div>
                  </div>
                </div>

                {/* RIGHT */}
                <div className="profile-right-panel">
                  <h4 className="section-title">Quick Overview</h4>

                  <div className="stats-grid">
                    <div className="stat-box">
                      <span>Total Attendance</span>
                      <strong>{overview?.totalAttendance ?? "-"}</strong>
                    </div>

                    <div className="stat-box">
                      <span>Total Leaves</span>
                      <strong>{overview?.totalLeaves ?? "-"}</strong>
                    </div>

                    <div className="stat-box">
                      <span>Approved Leaves</span>
                      <strong>{overview?.approvedLeaves ?? "-"}</strong>
                    </div>

                    <div className="stat-box">
                      <span>Pending Leaves</span>
                      <strong>{overview?.pendingLeaves ?? "-"}</strong>
                    </div>
                  </div>


                  <div className="quick-actions">
                    <button
                      className="action-btn"
                      onClick={() => window.location.href = `/attendance-history/${employee.id}`}
                    >
                      📅 View Attendance
                    </button>

                    <button
                      className="action-btn secondary"
                      onClick={() => window.location.href = `/leave-history/${employee.id}`}
                    >
                      📝 View Leave History
                    </button>
                  </div>
                </div>
              </div>


              {/* EXTRA SECTIONS */}
              {/* <div className="profile-extra">
              <div className="info-card">
                <h6>Address</h6>
                <p>{employee.address || "Not provided"}</p>
              </div>

              <div className="info-card">
                <h6>Status</h6>
                <p className="status-active">Active</p>
              </div>
            </div> */}

              {/* BANK DETAILS */}
              <div className="profile-extra">
                <div className="info-card">
                  <h3>Employee Bank Details</h3>

                  {bankDetails ? (
                    <>
                      <div className="profile-row">
                        <span>Account Holder</span>
                        <strong>{bankDetails.acc_holder_name}</strong>
                      </div>

                      <div className="profile-row">
                        <span>Account Number</span>
                        <strong>{bankDetails.acc_no}</strong>
                      </div>

                      <div className="profile-row">
                        <span>Bank Name</span>
                        <strong>{bankDetails.bank_name}</strong>
                      </div>

                      <div className="profile-row">
                        <span>Branch</span>
                        <strong>{bankDetails.branch_name}</strong>
                      </div>

                      <div className="profile-row">
                        <span>IFSC</span>
                        <strong>{bankDetails.ifsc_code}</strong>
                      </div>

                      <div className="profile-row">
                        <span>Account Type</span>
                        <strong>{bankDetails.account_type}</strong>
                      </div>

                      {/* DOWNLOAD BUTTON */}
                      <button
                        className="download-btn"
                        onClick={() =>
                          window.open(
                            `http://163.227.92.37:5556/profile/bank-details-excel/${id}`,
                            "_blank"
                          )
                        }
                      >
                        ⬇ Download Bank Details
                      </button>
                    </>
                  ) : (
                    <p>No bank details added</p>
                  )}
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}
